import { Pane, Text } from '@leverege/ui-elements'
import { ParentSize } from '@visx/responsive'
import { AnimatedAxis, AnimatedBarGroup, AnimatedBarSeries, DataProvider, Tooltip, XYChart } from '@visx/xychart'
import React from 'react'

import { chartTheme } from '../../../../util/Theme'
import ChartTypeSelector from '../../aisleHeatmapping/ChartTypeSelector'
import GenericTooltip from '../../views/GenericTooltip'
import useTrafficBarChart from '../hooks/useTrafficBarChart'
import ChartLegend from './ChartLegend'

export default function TrafficBarChart( props ) {
  const { data, config, type, onSetType } = useTrafficBarChart( props )
  return (
    <Pane variant="cardNoPad" layout="flex:col">
      <div style={{
        height : '60px',
        padding : 'var(--size-padLarge)',
        borderBottom : '1px solid var(--color-base100)'
      }}>
        <Text variant="subtitle">Traffic By Day of Week</Text>
      </div>
      <div style={{
        height : 'calc(100% - 60px)',
        padding : '0 var(--size-padLarge) var(--size-padLarge) var(--size-padLarge)'
      }}>
        <ParentSize parentSizeStyles={{
          position : 'relative',
          overflow : 'hidden',
          width : '100%',
          height : '100%'
        }}>
          {( { width, height } ) => ( 
            <DataProvider
              theme={chartTheme}
              xScale={config.scale.x}
              yScale={config.scale.y}>
              <XYChart
                width={width}
                height={height - 20}>
                <AnimatedAxis orientation="left" numTicks={10} label="Traffic" />
                <AnimatedAxis tickFormat={config.tickFormat.x} orientation="bottom" numTicks={data.length} />
                <AnimatedBarGroup>
                  <AnimatedBarSeries
                    dataKey="person"
                    data={data}
                    {...config.accessors.person} />
                  <AnimatedBarSeries
                    dataKey="dog"
                    data={data}
                    {...config.accessors.dog} />
                </AnimatedBarGroup>
                <Tooltip
                  scroll
                  detectBounds
                  snapTooltipToDatumX={false}
                  snapTooltipToDatumY={false}
                  renderTooltip={props => (
                    <GenericTooltip {...props} config={config} />
                  )} />
              </XYChart>
              <ChartLegend />
              <ChartTypeSelector small value={type} onChange={onSetType} />
            </DataProvider>
          )}
        </ParentSize>
      </div>
    </Pane>
  )
}
